export const extractSubdomainFromHost = (hostName?: string) => {
  const domainName = (process.env.REACT_APP_DOMAIN_NAME || '').split(':')[0];
  if (!hostName || !domainName) return;
  if (!hostName.endsWith(domainName)) return;
  const normalizedHostName = hostName.replace('www.', '');
  const domainIndex = normalizedHostName.indexOf('.' + domainName);
  if (domainIndex > 0) return normalizedHostName.substring(0, domainIndex);
};
